import { render, staticRenderFns } from "./morningClassPage.vue?vue&type=template&id=2e5eb2be&scoped=true&"
import script from "./morningClassPage.vue?vue&type=script&lang=js&"
export * from "./morningClassPage.vue?vue&type=script&lang=js&"
import style0 from "./morningClassPage.vue?vue&type=style&index=0&id=2e5eb2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5eb2be",
  null
  
)

export default component.exports